import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  updateEntityListDataMultiple,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { getSupplierProductItemsDataForSupplierProduct } from '../supplierProductItems/mockData'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getSupplierProductListData,
  getSupplierProductOverviewData,
  getSupplierProductWithSupplierProductItemsData,
} from './mockData'
import type {
  ISupplierProduct,
  ISupplierProductOverview,
  ISupplierProductWithItemsPropertyPopulated,
} from '~/types/supplierProduct/models'

interface GetSupplierProductsResponse {
  data: ISupplierProduct[] | undefined
}

async function getList(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`'Returning supplierProduct list.`)
  const responseBody: GetSupplierProductsResponse = {
    data: await getSupplierProductListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetSupplierProductOverviewResponse {
  data: ISupplierProductOverview | undefined
}

const getSupplierProductOverview = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  try {
    const responseBody: GetSupplierProductOverviewResponse = {
      data: await getSupplierProductOverviewData(id)!, // will either be valid or will have thrown error
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e) {
    const responseBody = {
      statusCode: 404,
      message: `Unable to retrieve supplierProduct overview for '${id}'`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

interface GetSupplierProductWithItemsResponse {
  data: ISupplierProductWithItemsPropertyPopulated
}

async function getSupplierProductWithItemsRecursiveById(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(`'Returning supplierProduct with items "${id}".`)
  const responseBody: GetSupplierProductWithItemsResponse = {
    data: await getSupplierProductWithSupplierProductItemsData({
      id,
      doReplaceSupplierProductInSupplierProductItemsWithEntitySelectItem: false,
    }),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// async function getItemsById(
//   req: RestRequest,
//   res: ResponseFunction,
//   ctx: RestContext
// ) {
//   const { id } = req.params
//   if (typeof id !== 'string') {
//     const responseBody = {
//       statusCode: 500,
//       message: 'Passed ID is not a string.',
//     }
//     return res(ctx.status(500), ctx.json(responseBody))
//   }
//   console.log(`'Returning supplierProduct items for supplierProduct "${id}".`)
//   const responseBody = {
//     data: await getSupplierProductItemsDataForSupplierProduct(id, false),
//   }
//   return res(ctx.status(200), ctx.json(responseBody))
// }

// post

const postSupplierProduct = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getSupplierProductListData)
}

const patchSupplierProduct = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getSupplierProductListData)
}

const patchSupplierProducts = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListDataMultiple(req, res, ctx, getSupplierProductListData)
}

const deleteSupplierProduct = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getSupplierProductListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/supplierproducts',
    handler: getList,
  },
  {
    method: 'get',
    path: '/api/supplierproducts/:id/overview',
    handler: getSupplierProductOverview,
  },
  {
    method: 'get',
    path: '/api/supplierproducts/:id/withitems',
    handler: getSupplierProductWithItemsRecursiveById,
  },
  {
    method: 'post',
    path: '/api/supplierproducts',
    handler: postSupplierProduct,
  },
  {
    method: 'patch',
    path: '/api/supplierproducts/:id',
    handler: patchSupplierProduct,
  },
  {
    method: 'patch',
    path: '/api/supplierproducts',
    handler: patchSupplierProducts,
  },
  {
    method: 'delete',
    path: '/api/supplierproducts/:id',
    handler: deleteSupplierProduct,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
